export default function galleryLightbox() {
  const containers = Array.from(
    document.querySelectorAll("[data-gallery-lightbox]")
  );
  if (!containers.length) return;

  const buildLightbox = () => {
    const root = document.createElement("div");
    root.className = "gallery-lightbox";
    root.hidden = true;
    root.innerHTML = `
      <div class="gallery-lightbox__backdrop" data-gallery-close></div>
      <div class="gallery-lightbox__dialog" role="dialog" aria-modal="true" aria-label="Gallery">
        <button class="gallery-lightbox__close" type="button" data-gallery-close aria-label="Close">×</button>
        <button class="gallery-lightbox__nav gallery-lightbox__prev" type="button" data-gallery-prev aria-label="Previous">
          <svg class="gallery-lightbox__chevron" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path d="M14 6 L8 12 L14 18" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </button>
        <figure class="gallery-lightbox__figure">
          <img class="gallery-lightbox__img" alt="" />
        </figure>
        <button class="gallery-lightbox__nav gallery-lightbox__next" type="button" data-gallery-next aria-label="Next">
          <svg class="gallery-lightbox__chevron" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path d="M10 6 L16 12 L10 18" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </button>
      </div>
    `;
    document.body.appendChild(root);
    return root;
  };

  const lightbox = buildLightbox();
  const imgEl = lightbox.querySelector(".gallery-lightbox__img");

  let activeImages = [];
  let activeIndex = 0;
  let lastFocused = null;

  const open = (images, index) => {
    activeImages = images;
    activeIndex = Math.max(0, Math.min(index, images.length - 1));

    lastFocused = document.activeElement;

    document.body.style.overflow = "hidden";
    lightbox.hidden = false;
    lightbox.classList.add("gallery-lightbox--open");

    render();
    const closeBtn = lightbox.querySelector(".gallery-lightbox__close");
    if (closeBtn) closeBtn.focus();
  };

  const close = () => {
    lightbox.classList.remove("gallery-lightbox--open");
    lightbox.hidden = true;
    document.body.style.overflow = "";

    // If the lightbox was opened via `#gallery`, clear the hash on close.
    const hash = (window.location.hash || "").toLowerCase();
    if (hash === "#gallery" || hash.startsWith("#gallery-")) {
      const nextUrl = `${window.location.pathname}${window.location.search}`;
      window.history.replaceState(null, "", nextUrl);
    }

    if (lastFocused && typeof lastFocused.focus === "function") {
      lastFocused.focus();
    }
  };

  const render = () => {
    const current = activeImages[activeIndex];
    if (!current) return;

    imgEl.src = current.src;
    imgEl.alt = current.alt || "";
  };

  const prev = () => {
    if (!activeImages.length) return;
    activeIndex = (activeIndex - 1 + activeImages.length) % activeImages.length;
    render();
  };

  const next = () => {
    if (!activeImages.length) return;
    activeIndex = (activeIndex + 1) % activeImages.length;
    render();
  };

  lightbox.addEventListener("click", (e) => {
    const t = e.target;
    if (!(t instanceof Element)) return;

    if (t.closest("[data-gallery-close]")) {
      close();
    } else if (t.closest("[data-gallery-prev]")) {
      prev();
    } else if (t.closest("[data-gallery-next]")) {
      next();
    } else if (
      t.classList.contains("gallery-lightbox__backdrop") ||
      t.classList.contains("gallery-lightbox__dialog") ||
      (t.classList.contains("gallery-lightbox__figure") &&
        !t.closest(".gallery-lightbox__img"))
    ) {
      // Clicking the background closes the lightbox (but clicking the image does not)
      close();
    }
  });

  document.addEventListener("keydown", (e) => {
    if (lightbox.hidden) return;

    if (e.key === "Escape") close();
    if (e.key === "ArrowLeft") prev();
    if (e.key === "ArrowRight") next();
  });

  const openFromHash = () => {
    const hash = (window.location.hash || "").toLowerCase();
    if (hash !== "#gallery") return;
    if (!lightbox.hidden) return;

    // Prefer a gallery near an element with id="gallery" if present, otherwise use first.
    const hashRoot = document.getElementById("gallery");
    const container =
      (hashRoot && hashRoot.querySelector("[data-gallery-lightbox]")) ||
      containers[0];
    if (!container) return;

    let images;
    try {
      images = JSON.parse(
        container.getAttribute("data-gallery-lightbox") || "[]"
      );
    } catch (e) {
      images = [];
    }
    if (!Array.isArray(images) || !images.length) return;

    open(images, 0);
  };

  for (const container of containers) {
    let images;
    try {
      images = JSON.parse(
        container.getAttribute("data-gallery-lightbox") || "[]"
      );
    } catch (e) {
      images = [];
    }

    if (!Array.isArray(images) || !images.length) continue;

    container.addEventListener("click", (e) => {
      const t = e.target;
      if (!(t instanceof Element)) return;

      const btn = t.closest("[data-gallery-open]");
      if (!btn) return;

      const idx = Number.parseInt(
        btn.getAttribute("data-gallery-index") || "0",
        10
      );
      open(images, Number.isNaN(idx) ? 0 : idx);
    });
  }

  // Auto-open lightbox when URL contains #gallery
  openFromHash();
  window.addEventListener("hashchange", openFromHash);
}
